export const empty = <T>(entry: T): entry is NonNullable<T> => entry !== null && entry !== undefined;

export const byType = <T>(type: Constructor<T>) => (
  entry: unknown,
): entry is T => entry instanceof type;
